import _ from 'lodash';
import { PILL_KEY } from './attributeConstants';

export class AttributeDefinitionValueListItem {
  public id: string;
  public itemValue: string;
  public itemDescription: string;
  public rank: number;
  public isActive: boolean;
  public added: boolean;
  public isOther: boolean = false;
  public color: PILL_KEY;

  constructor(
    id: string,
    itemValue: string,
    itemDescription: string,
    rank: number,
    isOther: boolean = false,
    color: PILL_KEY = null
  ) {
    this.id = id;
    this.itemValue = itemValue;
    this.itemDescription = itemDescription;
    this.rank = rank;
    this.isOther = isOther;
    this.color = color;
  }

  hasDescription() {
    return !_.isEmpty(_.trim(this.itemDescription));
  }

  static parse(obj: Partial<AttributeDefinitionValueListItem>): AttributeDefinitionValueListItem {
    return new AttributeDefinitionValueListItem(
      obj.id,
      obj.itemValue,
      obj.itemDescription,
      obj.rank,
      obj.isOther,
      obj.color
    );
  }

  static empty(): AttributeDefinitionValueListItem {
    return new AttributeDefinitionValueListItem(null, null, null, 0, false, null);
  }
}
